angular.module('activitiesScheduleComponents', []);
var asc = angular.module('activitiesScheduleComponents');